function Computer(data) {

    var self = this;

    if (typeof (data) === "undefined" || data === null) {
        return null;
    }

    // Private Variables
    var timeoutRefresh = 0;
    var updateInterval = 10 * 1000;
    var longInterval = 60 * 1000;

    var computerIcons = cccApp.enums.computerIcons;
    var refreshFunctions = [];
    var lastProcessedEvent = null;
    var agentOptionsOverrideExpires = 0;

    var refreshEvents = {
        softwareInstalled: 17,
        softwareUninstalled: 18,
        softwareUpdated: 25
    };

    // Observables
    self.name = ko.observable(data.name);
    self.agentVersion = ko.observable(data.agentVersion);
    self.isOnline = ko.observable(data.isOnline);
    self.guid = ko.observable(data.guid);
    self.operatingSystem = ko.observable(data.operatingSystem);
    self.ip = ko.observable(data.ip);
    self.specSummary = ko.observable(data.specSummary);
    self.boxType = ko.observable(data.boxType);
    self.isActive = ko.observable(data.isActive);
    self.lastOnline = ko.observable(data.lastOnline);
    self.lastOffline = ko.observable(data.lastOffline);
    self.serverGmtTime = ko.observable(data.serverGmtTime);
    self.isSelected = ko.observable(false);
    self.isConfirmed = ko.observable(data.isConfirmed);
    self.isPrivacyMode = ko.observable(data.isPrivacyMode);
    self.isReadOnly = ko.observable(data.isReadOnly);
    self.iconId = ko.observable(data.iconId);
    self.iconSize = ko.observable("md");
    self.order = ko.observable(data.order);
    self.groupTitle = ko.observable(data.groupTitle);
    self.groupId = ko.observable(data.groupId);
    self.groupChangedFrom = ko.observable(null);
    self.lastAction = ko.observable((data.lastAction) ? new ComputerLastAction(data.lastAction) : undefined);
    self.latestEvents = undefined;
    self.isLoading = ko.observable(true);
    self.driveList = ko.observable(null);
    self.lastRefreshTime = ko.observable(null);

    //Computeds
    self.onlineOfflineTitle = ko.computed(function() {

        var now = self.serverGmtTime() ? self.serverGmtTime() : Date.now();

        var timeZoneOffset = (typeof cccApp.user.timeZone !== "undefined") ? cccApp.user.timeZone : 0; //in minutes
        timeZoneOffset = timeZoneOffset * 60 * 1000; // in milliseconds

        var mdateUtc = moment.utc(new Date(self.lastOffline()));
        var mdateTZ;

        if (self.isOnline() && self.lastOnline() > -1 && self.lastOnline() <= now) {
            
            var difference = cccApp.dates.diff(self.lastOnline(), now);
            return difference ? "Online for " + difference : "";

        } else if (self.lastOffline() > -1 && self.lastOffline() <= now) {

            mdateTZ = moment.utc(new Date(self.lastOffline() + timeZoneOffset));
            var nowTZ = new Date(now + timeZoneOffset);
            var isToday = mdateTZ.isSame(moment.utc(nowTZ), "day");
            var isYesterday = mdateTZ.isSame(moment.utc(nowTZ).subtract(1, "day"), "day");

            if (isToday) {
                return "Last online " + mdateUtc.fromNow().toLowerCase();
            } else if (isYesterday) {
                return "Last online " + mdateTZ.calendar(nowTZ).toLowerCase();
            }
            return "Last online " + mdateTZ.format(cccApp.user.momentDateTimeFormat());

        }
        return "";
    });

    self.statusText = ko.computed(function() {
        if (self.isActive()) {
            return self.isOnline() ? "online" : "offline";
        } else {
            return "inactive";
        }
    });

    // Subscribes
    self.groupId.subscribe(function(newValue) {
        if (typeof newValue !== "undefined" && self.groupChangedFrom() === null) {
            self.groupChangedFrom(newValue);
        }
    });

    // Public Functions
    self.init = function() {
        self.isLoading(false);
    };

    self.icon = function(size) {
        self.iconSize(size || "md");

        return ko.computed(function() {
            var size = self.iconSize() || "md";
            var icon;

            if (typeof computerIcons !== "undefined") {
                icon = JSON.parse(JSON.stringify(computerIcons[self.iconId()]));
                icon.cssClass = icon.cssClass + " comp-ic-" + size;
            } else {
                icon = JSON.parse(JSON.stringify(computerIcons[0]));
                icon.cssClass = icon.cssClass + " comp-ic-" + size;
            }

            return icon;

        });
    };

    self.smallIcon = function() {
        var icon;

        if (typeof computerIcons !== "undefined") {
            icon = JSON.parse(JSON.stringify(computerIcons[self.iconId()]));
            icon.cssClass = icon.cssClass + " comp-ic-sm";
        } else {
            icon = JSON.parse(JSON.stringify(computerIcons[0]));
            icon.cssClass = icon.cssClass + " comp-ic-sm";
        }

        return icon;
    };

    self.resetGroupTracking = function() {
        self.groupChangedFrom(self.groupId());
    };

    self.update = function(pollForUpdates) {

        pollForUpdates = (typeof pollForUpdates === "boolean" && pollForUpdates) || false;

        cccApp.api.get({
            url: "network/hosts/" + self.guid(),
            global: false,
            queueKey: "computer-update-poll",
            errorMessage: "Sorry, there was an error retrieving the details of your computer",

            success: function(result) {
                if (result.data) {
                    if (agentOptionsOverrideExpires > new Date().valueOf()) {
                        if (self.isPrivacyMode() === result.data.isPrivacyMode && self.isReadOnly() === result.data.isReadOnly) {
                            agentOptionsOverrideExpires = 0;
                        } else {
                            result.data.isPrivacyMode = self.isPrivacyMode();
                            result.data.isReadOnly = self.isReadOnly();
                        }
                    }

                    ko.mapping.fromJS(result.data, {}, self);

                    //Trigger recalc of onlineOfflineTitle computed;
                    self.isOnline.valueHasMutated();
                }

                if (pollForUpdates) {
                    self.setPollingTimeout(false, false);
                }
            },
            error: function() {
                if (pollForUpdates) {
                    self.setPollingTimeout(false, true);
                }
            }
        });
    };

    self.setTemporaryAgentOptions = function(isReadOnly, isPrivacyMode) {
        self.isReadOnly(isReadOnly);
        self.isPrivacyMode(isPrivacyMode);

        agentOptionsOverrideExpires = new Date().valueOf() + (30 * 1000);
    };

    self.setPollingTimeout = function(clearOnly, useLongInterval) {
        clearTimeout(timeoutRefresh);

        if (typeof clearOnly !== "boolean" || !clearOnly) {
            timeoutRefresh = setTimeout(function() { self.update(true); },
                typeof useLongInterval !== "boolean" || !useLongInterval ? updateInterval : longInterval);
        }
    };

    self.save = function(placeholder, onComplete) {
        var computer = {
            name: self.name(),
            iconId: self.iconId()
        };

        var jsonData = ko.toJSON(computer);
        var success = false;

        cccApp.api.put({
            url: "network/hosts/" + self.guid(),
            data: jsonData,
            messagePlaceholder: placeholder,
            errorMessage: "Sorry, there was a problem saving the changes to your computer",
            success: function (result) {
                success = true;
            },
            complete: function () {
                if (typeof onComplete === "function") {
                    onComplete(success);
                }
            }
        });
    };

    self.delete = function(placeholder, onComplete) {
        // Pause timed events that could cause an Access Denied response whilst the delete is in progress
        pauseTimedEvents(true);
        var success = false;

        cccApp.api.delete({
            url: "network/hosts/" + self.guid(),
            messagePlaceholder: placeholder,
            errorMessage: "Sorry, there was a problem while deleting the computer",
            success: function(result) {
                success = true;
            },
            error: function(error) {
                // Restart events
                pauseTimedEvents(false);
            },
            complete: function() {
                if (typeof onComplete === "function") {
                    onComplete(success);
                }
            }
        });
    };

    self.addRefreshEventCallback = function(actionCallback, refreshTimeCallback) {
        refreshFunctions.push({
            actionCallback: actionCallback,
            refreshTimeCallback: refreshTimeCallback
        });
    };

    self.listenForRefreshEvents = function() {
        if (self.latestEvents && self.latestEvents.items) {
            if (self.latestEvents.items().length > 0) {
                lastProcessedEvent = self.latestEvents.items()[0];
            }

            self.latestEvents.items.subscribe(function(events) {
                for (var i = 0; i < events.length; i++) {
                    var event = events[0];

                    for (var j = 0; j < refreshFunctions.length; j++) {
                        var actionCallback = refreshFunctions[j].actionCallback;
                        var refreshTimeCallback = refreshFunctions[j].refreshTimeCallback;

                        if (actionCallback && refreshTimeCallback) {
                            // Is the event later than the previous 'latest' event and later than the last refresh through C3
                            if ((!lastProcessedEvent || event.dateUTC() > lastProcessedEvent.dateUTC()) && event.dateUTC() > refreshTimeCallback()) {
                                if (event.id === refreshEvents.softwareInstalled || event.id === refreshEvents.softwareUninstalled || event.id === refreshEvents.softwareUpdated) {
                                    try {
                                        actionCallback();
                                    } catch (error) {
                                        logError("Events Refresh Callback Error", false, error);
                                    }

                                    break;
                                }
                            } else {
                                // Events in reverse chronological order
                                break;
                            }
                        }
                    }
                }

                if (events.length > 0) {
                    lastProcessedEvent = events[0];
                }
            });
        }
    };

    // Private Functions
    function pauseTimedEvents(pause) {
        self.setPollingTimeout(pause);

        if (self.latestEvents) {
            self.latestEvents.setUpdateDatesTimeout(pause);
            self.latestEvents.setUpdateListTimeout(pause);
        }
    }

    return self;
}